import { centsToUnits as a } from "@systemeio/ui";
import { ShippingRuleTypeEnum as m } from "../../../../libs/types/dist/index2.mjs";
const p = (e, i, r, n = "narrowSymbol") => {
  try {
    return new Intl.NumberFormat(r, {
      style: "currency",
      currency: i,
      currencyDisplay: n
    }).format(e);
  } catch (s) {
    if (s instanceof RangeError && n !== "symbol")
      return p(e, i, r, "symbol");
    throw s;
  }
}, u = (e, i, r, n) => {
  switch (i.type) {
    case m.price:
      return e.max ? r("public_pages_purchase.shipping.condition_label.price", {
        min: p(a(e.min), i.currency, n),
        max: p(a(e.max), i.currency, n),
        currency: ""
      }) : r("public_pages_purchase.shipping.condition_label.price_min", {
        min: p(a(e.min), i.currency, n),
        currency: ""
      });
    case m.quantity:
      return e.max ? r("public_pages_purchase.shipping.condition_label.quantity", {
        min: e.min,
        max: e.max
      }) : r("public_pages_purchase.shipping.condition_label.quantity_min", {
        min: e.min
      });
    case m.weight:
      return e.max ? r("public_pages_purchase.shipping.condition_label.weight", {
        min: e.min,
        max: e.max
      }) : r("public_pages_purchase.shipping.condition_label.weight_min", {
        min: e.min
      });
    default:
      return "";
  }
};
export {
  u as getConditionLabel
};
